module.exports = __webpack_public_path__ + "media/assets/images/snow_sometime_will_sunny-2c8c9e01ba36ed95536937ed568b3ad6.png";